
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeFishingFilled as ObiVesselTypeFishingFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-fishing-filled.js';
 
 
 

 
 export const ObiVesselTypeFishingFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-fishing-filled',
   elementClass: ObiVesselTypeFishingFilledElement,
   events: {
     
   }
  });
 
 